<template>
  <v-container>
    <!-- Section to switch between components -->
     <div class="tabscontainer" >
    <v-row justify="center" class="mb-4">
      <v-col cols="4">
        <v-btn 
          color="primary" 
          @click="toggleComponent(true)" 
          >
          Show FlashSales Filter
        </v-btn>
      </v-col>
      <v-col cols="4">
        <v-btn 
          color="secondary" 
          @click="toggleComponent(false)" 
          >
          Show Skus Filter
        </v-btn>
      </v-col>
    </v-row>
  </div>

    <!-- Conditional Rendering for Components -->
    <GoogleAuthorization v-if="showToken" @validToken="validToken"></GoogleAuthorization>

    <!-- Show Other Component -->
    <div v-if="!showOtherComponent">
     <SkusFlashSale></SkusFlashSale>
    </div>

    <!-- Show FlashSalesFilter Component -->
    <FlashSalesFilter
      v-if="showOtherComponent && showFilter"
      @getProducts="getProducts"
      @getFilters="setFilters"
    ></FlashSalesFilter>

    <!-- The rest of the existing components remain unchanged -->
    <WholesalePriceEdit
      v-if="showPriceEdit && showOtherComponent "
      :products="products"
      @getSizes="getSizes"
      @backToFilter="backToFilter"
    ></WholesalePriceEdit>

    

    <OrderSizes
      v-if="showSizeOrder && showOtherComponent"
      :items="productsArray"
      @orderedSizes="afterSizeOrder"
      @backToFilter="backToFilter"
    ></OrderSizes>

    <v-card flat v-if="loadingFile" class="mt-12">
      <v-card-text>
        <v-row class="pb-2" justify="center">
          <v-img src="@/assets/loading.svg" max-width="200"> </v-img>
        </v-row>
        <v-row justify="center">
          <h3 class="basic--text">Please wait, the file is being created...</h3>
        </v-row>
        <v-row justify="center">
          <v-col cols="6">
            <v-progress-linear indeterminate color="accent"></v-progress-linear>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-card flat v-if="showInputs" v-model="valid" class="mt-12">
      <v-card-title>
        <v-row justify="center" class="basic--text">File info</v-row>
      </v-card-title>
      <v-form ref="form">
        <v-card-text>
          <v-row justify="center">
            <v-col cols="4">
              <v-text-field
                label="File name"
                v-model="filename"
                :rules="[rules.required]"
                filled
                clearable
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row justify="center">
            <v-col cols="4">
              <v-text-field
                label="Sheet title"
                v-model="sheetTitle"
                :rules="[rules.required]"
                filled
                clearable
              >
              </v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-row justify="end">
            <v-col cols="3">
              <v-btn color="error" outlined @click="backToFilter">
                <v-icon left color="error">mdi-arrow-left-bold</v-icon>
                Back to filter
              </v-btn>
            </v-col>
            <v-col cols="5">
              <v-btn
                color="success"
                outlined
                @click="getSpreadsheet"
                :disabled="!valid"
                >Get file
                <v-icon right color="success"
                  >mdi-arrow-right-bold</v-icon
                ></v-btn
              >
            </v-col>
          </v-row>
        </v-card-actions>
      </v-form>
    </v-card>

    <v-card flat v-if="fileResponse" class="mt-12">
      <v-card-text>
        <v-row class="pb-2" justify="center">
          <v-img :src="require(`@/assets/${responseImg}`)" max-width="300">
          </v-img>
        </v-row>
        <v-row justify="center" class="mt-10">
          <h2 :class="textColor">{{ responseText }}</h2>
        </v-row>
        <template v-if="fileCreationSuccess">
          <v-row justify="center" class="mt-10">
            <v-btn outlined color="success" @click="openFile">Open file</v-btn>
          </v-row>
          <v-row justify="center" class="mt-10">
            <h3 class="basic--text">Or copy link: <br />{{ fileLink }}</h3>
          </v-row>
          <v-row justify="center" class="mt-10">
            <h3 class="basic--text">Want to generate another file?</h3>
          </v-row>
          <v-row justify="center" class="mt-10">
            <h3 class="basic--text">Click the button below:</h3>
          </v-row>
        </template>
        <v-row justify="center" class="mt-10">
          <v-btn outlined color="accent" @click="generateNew"
            >Generate new <v-icon right>mdi-file-plus</v-icon></v-btn
          >
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import FlashSalesFilter from "../FlashSales/FlashSalesFilter";
import WholesalePriceEdit from "../FlashSales/WholesalePriceEdit";
import OrderSizes from "../FlashSales/OrderSizes";
import GoogleAuthorization from "./GoogleAuthorization.vue";
import SkusFlashSale from "./SkusFlashSale.vue";


export default {
  name: "FlashSalesGenerate",
  components: {
    FlashSalesFilter,
    WholesalePriceEdit,
    OrderSizes,
    GoogleAuthorization,
    SkusFlashSale
  },
  data: () => ({
    showToken: true,
    showFilter: false,
    showPriceEdit: false,
    showSizeOrder: false,
    loadingFile: false,
    fileResponse: false,
    showInputs: false,
    products: [],
    productsArray: [],
    orderedSizes: [],
    rules: {
      required: (value) => !!value || "Field is required.",
    },
    valid: false,
    filename: "",
    sheetTitle: "",
    responseText: "",
    responseImg: "",
    fileLink: "",
    brands: "",
    categories: undefined,
    condition: "",
    genders: "",
    textColor: "basic--text",
    fileCreationSuccess: false,
    showOtherComponent: true, // Default is FlashSalesFilter
  }),
  methods: {
    validToken() {
      this.showToken = false;
      this.showFilter = true;
    },
    getProducts(products) {
      this.showFilter = false;

      this.products = products;
      this.showPriceEdit = true;
    },
    getSizes(products) {
      this.productsArray = products;
      this.showPriceEdit = false;
      this.showSizeOrder = true;
    },
    afterSizeOrder(sizes) {
      this.orderedSizes = sizes;
      this.showSizeOrder = false;

      this.showInputs = true;
    },
    async getSpreadsheet() {
      this.showInputs = false;
      this.loadingFile = true;

      let data = await this.fillFormData();

      try {
        const response = await this.$store.dispatch("getSpreadsheet", data);
        this.textColor = "basic--text";
        this.responseImg = "completed.svg";
        this.loadingFile = false;
        this.fileResponse = true;
        this.fileCreationSuccess = true;

        const link = response.data;
        this.fileLink = link;
        window.open(link);

        this.responseText = `Success! File ${this.filename} created!`;
      } catch (error) {
        console.log(error);

        this.textColor = "red--text";
        this.responseImg = "empty.svg";
        this.loadingFile = false;
        this.fileResponse = true;
        this.responseText = error.response.data
          ? error.response.data
          : "Couldn't create file.";
        this.fileCreationSuccess = false;
      }
      this.filename = "";
      this.sheetTitle = "";
    },
    //fills formData with required information to get spreadsheet
    async fillFormData() {
      let formData = new FormData();

      formData.append("spreadSheetTitle", this.filename);

      formData.append("sheetTitle", this.sheetTitle);

      for (let i in this.orderedSizes) {
        formData.append("sizeOrder", this.orderedSizes[i]);
      }

      for (let indx in this.productsArray) {
        formData.append("products", JSON.stringify(this.productsArray[indx]));
      }

      if (this.brands != "") {
        for (let j in this.brands) {
          formData.append("brands", this.brands[j]);
        }
      }
      if (this.genders != "") {
        for (let j in this.genders) {
          formData.append("gender", this.genders[j]);
        }
      }

      if (this.categories) {
        for (let y in this.categories) {
          formData.append("categories", this.categories[y]);
        }
      }

      formData.append("condition", this.condition);

      return formData;
    },
    openFile() {
      window.open(this.fileLink);
    },
    setFilters(brand, condition, category, gender) {
      this.brands = brand;
      this.categories = category;
      this.condition = condition;
      this.genders = gender;
    },
    backToFilter() {
      this.showPriceEdit = false;
      this.showSizeOrder = false;
      this.showInputs = false;
      this.showFilter = true;
      this.fileResponse = false;
    },
    toggleComponent(isFlashSales) {
      this.showOtherComponent = isFlashSales;
    },
    generateNew() {
      this.showInputs = true;
      this.fileResponse = false;
    },
  },
};
</script>

<style>
.tabscontainer {
  width: 1900px;
}

</style>